<template>
  <div class="exam-paper container">
    <div class="header">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/course` }">在线课程</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/course/detail/${this.$route.params.courseId}` }">{{course.name}}</el-breadcrumb-item>
        <el-breadcrumb-item>随堂练习</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <div class="tips">
            <p class="label">
              <i class="el-icon-warning-outline"></i>
              题目编辑为实时保存，建议编辑时先关闭对应章节的上线状态，避免影响用户操作
            </p>
          </div>
        </div>
        <div class="right">
          <el-button type="primary">预览</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="title-wrap">
        <div class="input-box">
          <span>试卷名称：</span>
          <el-input v-model="paper.name"
                    placeholder="编辑试卷名称"
                    @change="handlePaperNameChange"></el-input>
        </div>
        <el-button type="primary">查看例子</el-button>
      </div>
      <div class="exam-wrap">
        <div class="exam-item"
             v-for="(item, $index) in pages[pageIndex]"
             :key="item.id">
          <Single v-if="item.answer_type === 0"
                  :title="`${computeIndex($index)+1} 单选题`"
                  :content="item"
                  @save="handleExamSave($event, $index)">
            <div style="display: flex;">
              <div v-if="$index != 0">
                <el-button type="text"
                           @click="handleExamSortChange(computeIndex($index), 'up')">上移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button type="text"
                           @click="handleExamSortChange(computeIndex($index), 'down')">下移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <el-button type="text"
                         @click="handleExamRemove(computeIndex($index))">删除</el-button>
            </div>
          </Single>
          <Multiple v-if="item.answer_type === 1"
                    :title="`${computeIndex($index)+1} 多选题`"
                    :content="item"
                    @save="handleExamSave($event, $index)">
            <div style="display: flex;">
              <div v-if="$index != 0">
                <el-button type="text"
                           @click="handleExamSortChange(computeIndex($index), 'up')">上移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button type="text"
                           @click="handleExamSortChange(computeIndex($index), 'down')">下移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <el-button type="text"
                         @click="handleExamRemove(computeIndex($index))">删除</el-button>
            </div>
          </Multiple>
          <Judge v-if="item.answer_type === 3"
                 :title="`${computeIndex($index)+1} 判断题`"
                 :content="item"
                 @save="handleExamSave($event, $index)">
            <div style="display: flex;">
              <div v-if="$index != 0">
                <el-button type="text"
                           @click="handleExamSortChange(computeIndex($index), 'up')">上移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button type="text"
                           @click="handleExamSortChange(computeIndex($index), 'down')">下移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <el-button type="text"
                         @click="handleExamRemove(computeIndex($index))">删除</el-button>
            </div>
          </Judge>
          <Qa v-if="[4,5,6,7,9,10,14].includes(item.answer_type)"
              :title="`${computeIndex($index)+1}${item.answer_type_text}`"
              :content="item"
              @save="handleExamSave($event, $index)">
            <div style="display: flex;">
              <div v-if="$index != 0">
                <el-button type="text"
                           @click="handleExamSortChange(computeIndex($index), 'up')">上移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button type="text"
                           @click="handleExamSortChange(computeIndex($index), 'down')">下移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <el-button type="text"
                         @click="handleExamRemove(computeIndex($index))">删除</el-button>
            </div>
          </Qa>
          <Material v-if="[8,11,12,13].includes(item.answer_type)"
                    :title="`${computeIndex($index)+1} ${item.answer_type_text}`"
                    :content="item"
                    @save="handleExamSave($event, $index)">
            <div style="display: flex;">
              <div v-if="$index != 0">
                <el-button type="text"
                           @click="handleExamSortChange(computeIndex($index), 'up')">上移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button type="text"
                           @click="handleExamSortChange(computeIndex($index), 'down')">下移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <el-button type="text"
                         @click="handleExamRemove(computeIndex($index))">删除</el-button>
            </div>
          </Material>
        </div>
        <div class="exam-add"
             v-if="pageIndex === pages.length-1">
          <p>+添加题目</p>
          <div class="exam-buttons">
            <el-button type="primary"
                       @click="handleExamItemAdd(0)">单选题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(1)">多选题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(3)">判断题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(4)">问答题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(5)">名词解释</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(6)">简答题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(7)">论述题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(8)">材料分析题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(9)">计算题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(10)">填空题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(11)">实验题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(12)">案例分析题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(13)"> 完型填空题</el-button>
            <el-button type="primary"
                       @click="handleExamItemAdd(14)"> 作文</el-button>

          </div>
        </div>
      </div>
    </div>
    <div class="pager">
      <div :class="{'page': true,'active': pageIndex === $index}"
           v-for="(item, $index) in pages"
           :key="$index"
           @click="handlePageChange($index)">{{$index+1}}</div>
    </div>
  </div>
</template>

<script>
import Single from '@/components/exam/Single'
import Multiple from '@/components/exam/Multiple'
import Judge from '@/components/exam/Judge'
import Qa from '@/components/exam/Qa'
import Material from '@/components/exam/Material'
import { courseOne } from '@/api/course'
import {
  examPaperOne,
  examPaperUpdate,
  examChapterUpdate,
  examPaperItemList,
  examPaperItemCreate,
  examPaperItemUpdate,
  examPaperItemsUpdate,
  examPaperItemDestroy,
} from '@/api/exam'

export default {
  components: {
    Single,
    Multiple,
    Judge,
    Qa,
    Material,
  },
  data() {
    return {
      course: {},
      paper: {},
      itemList: [],
      pageIndex: 0,
      pages: [[]],
    }
  },
  created() {
    this.fetchCourseInfo()
    this.fetchExamPaperInfo()
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    // 课程基本信息
    fetchCourseInfo() {
      courseOne({ id: this.$route.params.courseId }).then((res) => {
        this.course = res
      })
    },
    // 试卷基本信息
    fetchExamPaperInfo() {
      examPaperOne({ id: this.$route.params.paperId }).then((res) => {
        if (res) {
          this.paper = res
          this.fetchExamPaperItemList()
        }
      })
    },
    // 试卷题目列表
    fetchExamPaperItemList() {
      examPaperItemList({ paper_id: this.paper.id }).then((res) => {
        this.itemList = res.list || []
        this.itemList.forEach((item) => {
          if (item.options) {
            item.options.forEach((v) => {
              v.true_option = v.true_option === 1 ? true : false
            })
          }

          if (item.children) {
            item.children.forEach((subItem) => {
              if (subItem.options) {
                subItem.options.forEach((v) => {
                  v.true_option = v.true_option === 1 ? true : false
                })
              }
            })
          }
        })
        // 分组切割：避免性能问题
        this.itemListChunks()
      })
    },
    // 章节发布状态变更
    handleUpdateChapterStatus(value) {
      examChapterUpdate({ id: this.paper.id, status: value ? 1 : 0 })
        .then((res) => {})
        .catch((error) => {
          this.$message.error('章节在线状态更新异常')
          console.log('error: ', error)
        })
    },
    // 试卷名称变更
    handlePaperNameChange(value) {
      examPaperUpdate({ id: this.paper.id, name: value })
        .then((res) => {})
        .catch((error) => {
          this.$message.error('试卷名称更新异常')
          console.log('error: ', error)
        })
    },
    // 滚动到页面顶部
    scrollToTop() {
      document.querySelector('#content').scrollTop = 0
    },
    // 题目保存
    handleExamSave(event, index) {
      this.itemList[index].content = event
      if (event.itemList) {
        this.itemListChunks()
      }
    },
    // 题目排序
    handleExamSortChange(index, type) {
      let old = this.itemList.splice(index, 1)[0]
      if (type == 'up') {
        this.itemList.splice(index - 1, 0, old)
      } else if (type == 'down') {
        this.itemList.splice(index + 1, 0, old)
      }
      this.itemListChunks()
      const rows = this.itemList.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      examPaperItemsUpdate(rows)
        .then((res) => {})
        .catch((error) => {
          this.$message.error('题目排序更新异常')
          console.log('error: ', error)
        })
    },
    // 题目删除
    handleExamRemove(index) {
      examPaperItemDestroy({ id: this.itemList[index].id }).then((res) => {
        this.itemList.splice(index, 1)
        this.itemListChunks()
      })
    },
    // 题目添加
    handleExamItemAdd(type) {
      let itemValue = {
        paper_id: this.paper.id,
        answer_type: type,
        sort: this.itemList.length,
      }
      if (type === 8) {
        itemValue.material = 1
      }
      examPaperItemCreate(itemValue).then((res) => {
        if (res.options) {
          res.options.forEach((v) => {
            v.true_option = v.true_option === 1 ? true : false
          })
        }
        this.itemList.push(res)
        this.itemListChunks()
      })
    },
    // 分页
    handlePageChange(index) {
      this.pageIndex = index
      this.scrollToTop()
    },
    // 索引值计算
    computeIndex(index) {
      const pages = this.pages
      const temps = pages.slice(0, this.pageIndex)
      const length = [].concat(...temps).length
      return length + index
    },
    // 题库列表分割
    itemListChunks() {
      // 20题左右一组
      const totalItems = this.itemList
      const pages = [[]]
      totalItems.forEach((item) => {
        let last = pages[pages.length - 1]
        let length = last.length
        // 材料题
        if (item.material) {
          length += item.children ? item.children.length : 1
        } else {
          length += 1
        }
        last.push(item)
        if (length >= 20) {
          pages.push([])
        }
      })
      this.pages = pages
    },
  },
}
</script>

<style scoped lang="less">
.exam-paper {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .tips {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title-wrap {
      display: flex;
      justify-content: space-between;
    }
    .input-box {
      display: flex;
      align-items: center;
      flex: 1;

      .el-input {
        width: 320px;
      }
    }
    .exam-item {
      margin-top: 20px;
    }
    .exam-add {
      position: relative;
      color: #303133;
      background-color: #fff;
      border: 1px dashed #0091ff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      overflow: hidden;
      padding: 20px;
      margin-top: 20px;

      display: flex;
      flex-direction: column;
      align-items: center;

      .exam-buttons {
        margin-top: 10px;

        /deep/ .el-button {
          padding: 10px 30px;
          margin: 10px 20px;
        }
      }
    }
  }
  .pager {
    position: fixed;
    top: 50%;
    right: 10px;
    transform: translate(0, -50%);

    .page {
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 16px;
      color: #606266;
      background: rgb(198, 226, 255);
      border-radius: 50%;
      cursor: pointer;

      & + .page {
        margin-top: 5px;
      }

      &.active {
        color: #fff;
        background: #409eff;
        cursor: default;

        &:hover {
          color: #fff;
        }
      }
      &:hover {
        color: #409eff;
      }
    }
  }
}
</style>
